<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const emit = defineEmits(['changeLanguage', 'logout', 'close']);

const store = useStore();

const selectedLang = ref(sessionStorage.getItem('lang') ?? 'ru');
const languages = [
    { title: 'РУС', value: 'ru' },
    { title: 'ҚАЗ', value: 'kk' },
    { title: 'ENG', value: 'en' },
];

const authorized = computed(() => {
    return store.state.token ? true : false;
});

const fioLink = computed(() => {
    const role = store.state.role;
    if (role === 'USER CC' || role === 'USER DZO' || role === 'USER') return '/my_resume';
    else return '/admin/profile';
});
</script>

<template>
    <v-navigation-drawer
        temporary
        location="left"
    >
        <v-list nav dense>
            <v-list-item append-icon="mdi-menu-open" @click.stop="emit('close')" />

            <v-divider class="my-1" />
            
            <v-list-item>
                <v-label>{{ $t('general.change_lang') }}</v-label>
                <v-select 
                    variant="solo" 
                    flat 
                    hide-details
                    :items="languages"
                    v-model="selectedLang"
                    @update:modelValue="emit('changeLanguage', selectedLang); emit('close')"
                />
            </v-list-item>

            <v-divider class="my-1" />

            <v-list-item to="/" :title="$t('home')" />
            <v-list-item to="/vacancies" :title="$t('general.vacancies')" />
            <v-list-item to="/contacts" :title="$t('main.contacts')" />
            <v-list-item to="/about" :title="$t('main.about_company')" />
            <v-list-item to="/steps" :title="$t('main.selection_stages')" class="title-uppercase" />
            <v-list-item to="/for_students" :title="$t('general.for_students')" />
            <v-list-item to="/faq" :title="$t('main.faq')" />

            <template v-if="authorized">
                <v-list-item to="/my_responses" :title="$t('resume.my_responses')" />
                <v-list-item to="/subscribes" :title="$t('resume.subscribe')" />
                <v-list-item to="/change_password" :title="$t('login.change_password')" />
            </template>

            <v-divider class="my-2" />

            <v-list-item
                v-if="authorized"
                :title="$t('btns.profile')"
                :to="fioLink"
                @click="emit('close')"
            />
            <v-list-item
                v-if="authorized"
                :title="$t('btns.logout')"
                @click="emit('logout'); emit('close')"
            />
            <v-list-item
                v-if="!authorized"
                :title="$t('btns.to_come_in')"
                @click="$router.push('/login'); emit('close')"
            />
            <v-list-item
                v-if="!authorized"
                :title="$t('btns.create_resume')"
                @click="$router.push('/login'); emit('close')"
            />
        </v-list>
    </v-navigation-drawer>
</template>